import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const CreateObservationFromManualFindingDocument = gql`
  mutation CreateObservationFromManualFinding(
    $user: String!
    $effectiveDateTime: String!
    $datasetId: String!
    $subjectRef: String!
    $finding: String!
  ) {
    createObservation(
      observation: {
        resourceType: Observation
        effectiveDateTime: $effectiveDateTime
        subject: { reference: $subjectRef }
        code: {
          coding: [
            {
              code: "51968-6"
              system: "http://loinc.org"
              display: "Discrete variation analysis overall interpretation"
            }
          ]
        }
        meta: {
          tag: [
            { code: $datasetId, system: "http://lifeomic.com/fhir/dataset" }
            {
              code: "LifeOmic Variant Selection"
              system: "http://lifeomic.com/fhir/source"
            }
          ]
        }
        performer: { identifier: { id: $user } }
        status: preliminary
        component: [
          {
            code: {
              coding: [
                {
                  system: "http://hl7.org/fhir/uv/genomics-reporting/CodeSystem/tbd-codes-cs"
                  code: "conclusion-string"
                }
              ]
            }
            valueString: $finding
          }
        ]
        extension: []
      }
    ) {
      id
      code {
        coding {
          system
          code
          display
        }
      }
      extension {
        url
        valueString
      }
      component {
        code {
          coding {
            code
            system
            display
          }
        }
        valueString
        valueCodeableConcept {
          coding {
            code
            system
            display
          }
        }
        valueQuantity {
          value
          system
          code
        }
      }
      effectiveDateTime
      status
      resourceType
      meta {
        tag {
          system
          code
        }
        lastUpdated
        versionId
      }
      subject {
        reference
      }
    }
  }
`;
export type CreateObservationFromManualFindingMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateObservationFromManualFindingMutationResponse,
    CreateObservationFromManualFindingMutationVariables
  >;

/**
 * __useCreateObservationFromManualFindingMutation__
 *
 * To run a mutation, you first call `useCreateObservationFromManualFindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationFromManualFindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObservationFromManualFindingMutation, { data, loading, error }] = useCreateObservationFromManualFindingMutation({
 *   variables: {
 *      user: // value for 'user'
 *      effectiveDateTime: // value for 'effectiveDateTime'
 *      datasetId: // value for 'datasetId'
 *      subjectRef: // value for 'subjectRef'
 *      finding: // value for 'finding'
 *   },
 * });
 */
export function useCreateObservationFromManualFindingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateObservationFromManualFindingMutationResponse,
    CreateObservationFromManualFindingMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateObservationFromManualFindingMutationResponse,
    CreateObservationFromManualFindingMutationVariables
  >(CreateObservationFromManualFindingDocument, baseOptions);
}
export type CreateObservationFromManualFindingMutationHookResult = ReturnType<
  typeof useCreateObservationFromManualFindingMutation
>;
export type CreateObservationFromManualFindingMutationResult =
  ApolloReactCommon.MutationResult<CreateObservationFromManualFindingMutationResponse>;
export type CreateObservationFromManualFindingMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateObservationFromManualFindingMutationResponse,
    CreateObservationFromManualFindingMutationVariables
  >;
export type CreateObservationFromManualFindingMutationVariables = Types.Exact<{
  user: Types.Scalars['String'];
  effectiveDateTime: Types.Scalars['String'];
  datasetId: Types.Scalars['String'];
  subjectRef: Types.Scalars['String'];
  finding: Types.Scalars['String'];
}>;

export type CreateObservationFromManualFindingMutationResponse = {
  __typename: 'Mutation';
  createObservation: {
    __typename: 'Observation';
    id?: Types.Maybe<string>;
    effectiveDateTime?: Types.Maybe<string>;
    status?: Types.Maybe<Types.ObservationStatus>;
    resourceType: Types.ObservationResourceType;
    code?: Types.Maybe<{
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
          display?: Types.Maybe<string>;
        }>
      >;
    }>;
    extension?: Types.Maybe<
      Array<{
        __typename: 'Extension';
        url?: Types.Maybe<string>;
        valueString?: Types.Maybe<string>;
      }>
    >;
    component?: Types.Maybe<
      Array<{
        __typename: 'ObservationComponent';
        valueString?: Types.Maybe<string>;
        code?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueCodeableConcept?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueQuantity?: Types.Maybe<{
          __typename: 'Quantity';
          value?: Types.Maybe<number>;
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>;
      }>
    >;
    meta?: Types.Maybe<{
      __typename: 'Meta';
      lastUpdated?: Types.Maybe<string>;
      versionId?: Types.Maybe<string>;
      tag?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    }>;
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
  };
};
